import {asCreator, withCallbacks} from '../../../../lib/utils';
import {compose} from '../../../../utils/functions';
import {actionTypes} from '../../reducers/notificationsReducer';

// Applies a staged household address/house-phone change to the household (the apply step that
// follows update-new-address). Call with { id, onSuccess, onError }.
export const confirmNewAddressNotification = compose(
    withCallbacks,
    asCreator((data: any) => ({
        type: actionTypes.CONFIRM_ADDRESS_NOTIFICATION,
        payload: data,
    }))
);
